import { gsap, Power1 } from "gsap/dist/gsap.min.js";

export default {
	data() {
		return {
			currentStage: 0,
			scrollyData: {},
		}
	},
	methods: {
		createTimeline(duration, onComplete) {
			return gsap.timeline({
				defaults: {
					duration: duration,
					ease: Power1.easeInOut
				},
				...onComplete,
				paused: true
			});
		},
		introAnimation() {
			let t1 = this.createTimeline(1)

			let section = this.getSectionById('s1');
			let step1 = this.getSectionById('s1').steps[0];
			let step2 = this.getSectionById('s1').steps[1];

			t1.to('.scrolly-intro-1 .scrolly-title-cont', {transform: 'translate(200%, -50%)'}, 0)
			t1.to('.scrolly-intro-1 .scrolly-intro-image', {transform: 'translate(-150%, 22%) rotate(-90deg)'}, 0)
			t1.to('.scrolly-intro-contents-cont', {transform: 'translate(calc(50vw - var(--menu-size) - 50%), calc(50vh - 50%))'}, 0)

			// t1.to('.scrolly-intro-1', {top: '-100%'}, 0)
			// t1.to('.scrolly-intro-2', {top: '0'}, 0);

			// t1.to('.scrolly-intro-1', {opacity: 0}, 0);
			// t1.to('.scrolly-intro-2-curtain', {zIndex: 1, duration: 0}, 0);
			// t1.to('.scrolly-intro-2-curtain', {opacity: 0.8, duration: 0}, 0);
			// t1.to('.scrolly-intro-2', {opacity: 1, duration: 0}, 0);
			// t1.to('.scrolly-instructions', {transform: 'translate(-50%, -30vh)', opacity: 0}, 0);
			let numIntroImages = document.querySelectorAll('.scrolly-intro-1-image').length
			// console.log(numIntroImages)
			if(numIntroImages == 1) {
				t1.to('.scrolly-intro-1-image-1', {transform: 'translate(calc(100vw - 100%), calc(100vh - 100%))'}, 0)
			}
			if (numIntroImages == 2) {
				t1.to('.scrolly-intro-1-image-1', {transform: 'translate(calc(100vw - 100%), calc(100vh - 100%))'}, 0)
				t1.to('.scrolly-intro-1-image-2', {transform: 'translate(-30%, calc(100vh - 80%)) rotate(-20deg)'}, 0)
			}
			if(numIntroImages == 3) {
				t1.to('.scrolly-intro-1-image-1', {transform: 'translate(calc(100vw - 100%), calc(100vh - 100%))'}, 0)
				t1.to('.scrolly-intro-1-image-2', {transform: 'translate(-30%, calc(100vh - 80%)) rotate(-20deg)'}, 0)
				t1.to('.scrolly-intro-1-image-3', {transform: 'translate(calc(50vw - 30%), -30%) rotate(15deg)'}, 0)
			}
			// t1.to('.scrolly-intro-2', {zIndex: 0, duration: 0}, 0.5);
			// t1.to('.scrolly-intro-1', {zIndex: -1, duration: 0}, 0.5);

			let t2 = this.createTimeline(0.5)
			t2.to('.scrolly-intro-1', {height: 0})

			step1.enterBackCb = () => {
				// this.setInhibitScroll();
				t1.reverse()
			}

			step2.enterCb = () => {
				// this.setInhibitScroll();
				t1.play()
			}

			this.getSectionById('s1').leaveCb = () => {
				// this.setInhibitScroll();
				t2.play();
			}

			this.getSectionById('s1').enterBackCb = () => {
				// this.setInhibitScroll();
				t2.reverse();
			}

			t1.eventCallback('onComplete', () => {
				// this.resetInhibitScroll();
			})
			t1.eventCallback('onReverseComplete', () => {
				// this.resetInhibitScroll();
			})

			t2.eventCallback('onComplete', () => {
				// this.resetInhibitScroll();
				const event = new Event("introfolded");
				window.dispatchEvent(event);
			})

			t2.eventCallback('onReverseComplete', () => {
				// console.log('reverse complete')
				// this.resetInhibitScroll();
				const event = new Event("introfolded");
				window.dispatchEvent(event);
			})

			this.scrollyTimelines['s1'] = [t1, t2]
		}
	}
}